/**
 * Shared config from wp_localize_script.
 */
export function getSettings() {
	return window.wcQuickBuySettings || {};
}

export function getConfig() {
	const settings = getSettings();
	return settings.config || {};
}

export function getLabels() {
	return getConfig().labels || {};
}
